import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/calendar/")({
  beforeLoad: () => {
    return redirect({ to: "/calendars" });
  },
});
